import { picoapp } from 'picoapp'

import slaterWelcome from '@/components/slater-welcome.js'

import header from '@/components/header.js'
import productSelection from '@/components/product-selection.js'
import cartDrawer from '@/components/cartDrawer.js'
import cartDrawerItem from '@/components/cartDrawerItem.js'
import menuDrawer from '@/components/menuDrawer.js'
import accountLogin from '@/components/accountLogin.js'
import product from '@/components/product.js'
import productPreLaunch from '@/components/product-pre-launch.js'
import productCounter from '@/components/product-counter.js'
import curtain from '@/components/curtain.js'
import productItem from '@/components/product-item.js'
import artistItem from '@/components/artistItem.js'
import artistGallery from '@/components/artistGallery.js'

const state = {
  cartOpen: false,
  menuOpen: false,
  curtainOpen: false
}

const components = {
  slaterWelcome,
  accountLogin,
  header,
  productSelection,
  cartDrawer,
  cartDrawerItem,
  menuDrawer,
  product,
  productPreLaunch,
  productCounter,
  curtain,
  productItem,
  artistItem,
  artistGallery
}

export default picoapp(components, state)
